import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';
import template from 'lodash.template';

import { GIFTCARD_UNAVAILABLE_VALUE } from 'constants/appConstants';

import { CheckAlt } from 'components/icons';
import css from 'styles/components/account/giftCardRedeem.scss';
import marketplace from 'cfg/marketplace.json';
const { account: { giftCardTerm } } = marketplace;

class GiftCardRedeem extends Component {
  state = {
    startingGiftCardBalance: this.props.giftCardBalance
  };

  componentDidUpdate(prevProps) {
    const { giftCardBalance: prevGiftCardBalance } = prevProps;
    const { giftCardBalance } = this.props;

    // Store previous gift card value so that it could animate
    // from a lower number to a higher number when GC is redeemed
    if (prevGiftCardBalance !== giftCardBalance) {
      this.setState({ startingGiftCardBalance: prevGiftCardBalance });
    }
  }

  makeGiftCardBalance = (startingGiftCardBalance, giftCardBalance) => {
    const { testId } = this.context;

    const hasGiftCardBalance = giftCardBalance !== GIFTCARD_UNAVAILABLE_VALUE && startingGiftCardBalance !== GIFTCARD_UNAVAILABLE_VALUE;
    if (startingGiftCardBalance === GIFTCARD_UNAVAILABLE_VALUE && giftCardBalance !== GIFTCARD_UNAVAILABLE_VALUE) {
      startingGiftCardBalance = 0;
    }

    return (<div className={css.giftCardBalance} data-test-id={testId('gcBalance')}>
      <div>Your gift card balance</div>
      {hasGiftCardBalance ?
        (<CountUp
          duration={1}
          decimals={2}
          prefix="$"
          separator=","
          start={startingGiftCardBalance}
          end={giftCardBalance}/>)
        : (<span>{GIFTCARD_UNAVAILABLE_VALUE}</span>)
      }
    </div>);
  }

  render() {
    const { testId } = this.context;
    const { startingGiftCardBalance } = this.state;
    const {
      giftCardBalance,
      giftCardRedeemCode,
      giftCardRedeemError,
      isGiftCardRedeemed,
      isGiftCardRedeemLoading,
      onUpdateGiftCardRedeemCode,
      onGiftCardRedeemSubmit
    } = this.props;

    return (
      <div className={css.giftCardSection}>
        <div className={css.giftCardRedeem}>
          <form method="post" onSubmit={onGiftCardRedeemSubmit}>
            <label htmlFor="claimCode">Enter {giftCardTerm} code to redeem</label>
            <div className={css.inputGroup}>
              <input
                type="text"
                id="claimCode"
                value={giftCardRedeemCode}
                onChange={onUpdateGiftCardRedeemCode}
                disabled={isGiftCardRedeemLoading}
                data-test-id={testId('gcReedemInput')}
                required/>
              <span className={css.inputGroupButton}>
                <button type="submit" disabled={isGiftCardRedeemLoading} data-test-id={testId('gcRedeemButton')}>
                  Save to Your Account
                </button>
              </span>
            </div>
            {isGiftCardRedeemed && (
              <div className={css.success} data-test-id={testId('gcAddedSucess')}>
                <CheckAlt/>Your {giftCardTerm} has been successfully redeemed.
              </div>
            )}
            {giftCardRedeemError && (
              <div className={css.error} data-test-id={testId('gcAddedFailure')}>
                {template(giftCardRedeemError)({ giftCardTerm })}
              </div>
            )}
          </form>
        </div>
        { this.makeGiftCardBalance(startingGiftCardBalance, giftCardBalance)}
      </div>
    );
  }
}

GiftCardRedeem.contextTypes = {
  testId: PropTypes.func
};

GiftCardRedeem.propTypes = {
  giftCardBalance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  giftCardRedeemCode: PropTypes.string.isRequired,
  giftCardRedeemError: PropTypes.string.isRequired,
  isGiftCardRedeemed: PropTypes.bool.isRequired,
  isGiftCardRedeemLoading: PropTypes.bool.isRequired,
  onUpdateGiftCardRedeemCode: PropTypes.func.isRequired,
  onGiftCardRedeemSubmit: PropTypes.func.isRequired
};

export default GiftCardRedeem;
